<template>
	<div class="relative w-full py-10 px-10">
		<div class="relative w-full flex flex-col justify-center items-start gap-4 z-20">
			<span class="text-xl md:text-2xl lg:text-3xl font-display font-semibold text-charcoal">
				{{ $t('aboutPage.title') }}
			</span>

			<p class="text-md md:text-lg text-charcoal">
				{{ $t('aboutPage.intro') }}
			</p>

			<p class="text-md md:text-lg text-charcoal">
				{{ $t('aboutPage.text') }}
			</p>

			<div class="w-full flex flex-wrap gap-2">
				<div
					v-for="service in services"
					:key="service.name"
					class="flex w-fit justify-start items-center gap-2 rounded p-1 md:p-2 pr-3 md:pr-4 border border-olive"
				>
					<component :is="service.icon" :width="20" :height="20" color="#3A3226" class="scale-[0.8] md:scale-[1]"/>
					<span class="text-xs md:text-sm font-normal text-charcoal">
						{{ $t(service.name) }}
					</span>
				</div>
			</div>

			<div class="flex flex-col justify-center items-start mt-4 gap-0.5">
				<span class="text-md md:text-lg text-olive font-display">
					{{ $t('aboutPage.explore') }}:
				</span>
				<div class="flex justify-start items-center gap-2 flex-wrap">
					<a
						v-for="link, i in discoverLinks"
						:key="i"
						:href="link.link"
						target="_blank"
						class="text-md md:text-lg text-charcoal text-left underline hover:underline-offset-2 pr-2 border-olive"
						:class="i === discoverLinks.length - 1 ? 'border-0' : 'border-r'"
					>
						<span>{{ $t(link.name) }}</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { services, discoverLinks } from '@/assets/config/infoConfig';

export default {
	name: 'AboutPage',
	setup() {
		return {
			services,
			discoverLinks,
		};
	},
};
</script>
